<button
  (clickOutside)="closeDropdown()"
  [isHandleClick]="isOpen"
  [class.disabled]="disabled"
  [attr.id]="id"
  [class.focus]="isOpen"
  class="app-select !h-full"
  (focus)="onFocus($event)"
  (keydown.enter)="openDropdownOnEnter($event, dropdown)"
  (click)="openDropdown($event, dropdown)">
  <ng-container *ngIf="!withoutSearch">
    <ng-container *ngIf="!isOpen; else searchTpl">
      <ng-container *ngIf="isFilter">
        <div class="ellipsis">
          <span class="label-title">{{ filterLabel | translate }}</span
          ><span>: &nbsp;</span>
        </div>
      </ng-container>

      <ng-container
        *ngTemplateOutlet="
          selectedOptionTemplate;
          context: {
            $implicit: model
          }
        "></ng-container>

      <ng-container *ngIf="!selectedOptionTemplate">
        <div class="label-text ellipsis">
          {{ label | translate }}
        </div>
      </ng-container>
    </ng-container>

    <ng-template #searchTpl>
      <app-select-search-input
        (click)="$event.stopPropagation()"
        [placeholder]="placeholder | translate"
        [searchFormControl]="searchControl">
      </app-select-search-input>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="withoutSearch">
    <ng-container *ngIf="isFilter">
      <div class="nowrap">
        <span class="label-title">{{ filterLabel | translate }}</span
        ><span>: &nbsp;</span>
      </div>
    </ng-container>

    <span class="label-text text-ellipsis">
      {{ label | translate }}
    </span>
  </ng-container>

  @if (withArrow) {
    <span class="app-select__arrow" [class.opened]="isOpen"> </span>
  }
</button>

<ng-template #dropdown>
  <div [style.width.px]="maxWidth" class="select-menu {{ dropdownClass }}">
    <div
      #scrollContainer
      class="select-menu-inner select-infinite-scroll-container"
      infinite-scroll
      [infiniteScrollContainer]="'.select-infinite-scroll-container'"
      [fromRoot]="true"
      [infiniteScrollDistance]="1"
      [infiniteScrollUpDistance]="2"
      [infiniteScrollThrottle]="300"
      (scrolled)="onScroll()"
      [style.max-height]="config.maxHeight">
      <div
        *ngIf="withNone && optionList.length"
        [class.selected]="activeItemIndex === -1"
        class="select-item none"
        (click)="select(null, $event)">
        <span> {{ noneWord | translate }} </span>
      </div>

      <div class="no-search-items" *ngIf="collection && !collection.loading && !collection.items.length">
        {{ noResult | translate }}
      </div>

      <div class="no-search-items" *ngIf="!collection && !optionList.length">
        {{ noResult | translate }}
      </div>

      <ng-container [ngTemplateOutlet]="optionsLoop" [ngTemplateOutletContext]="{ options: optionList }"> </ng-container>
    </div>

    <ng-container *ngIf="collection && (collection.loading$ | async)">
      <div class="loader-wrap">
        <loader [loading]="collection.loading$" [small]="true"></loader>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #optionItem let-option="option" let-index="index">
  <div
    class="select-item"
    [class.selected]="getSelected(option) || activeItemIndex === index"
    [class.ml-1]="getSubItem(option)"
    (click)="select(option, $event)">
    <span class="text-ellipsis">
      <ng-container
        *ngTemplateOutlet="
          optionTemplate;
          context: {
            $implicit: option
          }
        "></ng-container>

      <ng-container *ngIf="!optionTemplate">
        {{ getOptions(option, displayKey) | translate }}
      </ng-container>
    </span>
  </div>

  <!-- TODO  implement for sub items -- refactor key up/down functionality-->
  <!--  <div class="ml-1" *ngIf="option?[childKey]?.length && false">-->
  <!--    <ng-container [ngTemplateOutlet]="optionsLoop"-->
  <!--                  [ngTemplateOutletContext]="{ options: option?.subprojects }">-->
  <!--    </ng-container>-->
  <!--  </div>-->
</ng-template>

<ng-template #optionsLoop let-options="options">
  <ng-container *ngIf="options?.length">
    <ng-container *ngFor="let option of options; let i = index">
      <ng-container [ngTemplateOutlet]="optionItem" [ngTemplateOutletContext]="{ option: option, index: i }"> </ng-container>
    </ng-container>
  </ng-container>
</ng-template>
